import AgeRestrictionsSettings from './components/AgeRestrictionsSettings';

export default AgeRestrictionsSettings;
